import React, { useEffect, useState } from "react";
import { Card, Row, Col, Input } from "antd";
import NumberFormat from "react-number-format";
import { numberMask } from "../../../../services/helpersMethodsService";

const { TextArea } = Input;

const DailyContractCard = ({
  herds = [],
  values,
  setFieldValue,
  errors,
  submitCount,
  translation,
}) => {
  const [dailyValues, setDailyValues] = useState({
    protocolValue: values.dailyContract?.protocolValue || null,
    fixedValue: values.dailyContract?.fixedValue || null,
    dietValue: values.dailyContract?.dietValue || null,
    otherValue: values.dailyContract?.otherValue || null,
    dailyValue: values.dailyContract?.dailyValue || null,
    observation: values.dailyContract?.observation || "",
  });

  const [herdsWithDays, setHerdsWithDays] = useState(() => {
    return (herds || []).map((herd) => ({
      ...herd,
      numberOfDays: values.dailyContract?.herdsWithDays?.find(
        (h) => h.id === herd.id
      )?.numberOfDays || null,
    }));
  });

  useEffect(() => {
    const herdsIds = herds.map((h) => h.id).sort().join(",");
    const currentIds = herdsWithDays.map((h) => h.id).sort().join(",");

    if (herdsIds !== currentIds) {
      const updated = herds.map((herd) => {
        const existing = herdsWithDays.find((h) => h.id === herd.id);
        return {
          ...herd,
          numberOfDays: existing?.numberOfDays || null,
        };
      });
      setHerdsWithDays(updated);
    }
  }, [herds, herdsWithDays]);

  useEffect(() => {
    const herdsData = herdsWithDays.map((h) => ({
      id: h.id,
      numberOfDays: h.numberOfDays,
    }));
    setFieldValue("dailyContract", {
      ...dailyValues,
      herdsWithDays: herdsData,
    });
  }, [herdsWithDays, dailyValues, setFieldValue]);

  const handleHerdDaysChange = (herdId, value) => {
    setHerdsWithDays((prev) =>
      prev.map((h) =>
        h.id === herdId ? { ...h, numberOfDays: value } : h
      )
    );
  };

  const handleValueChange = (field, value) => {
    const newValues = { ...dailyValues, [field]: value };

    if (field !== "dailyValue") {
      const fixed = field === "fixedValue" ? (value || 0) : (dailyValues.fixedValue || 0);
      const diet = field === "dietValue" ? (value || 0) : (dailyValues.dietValue || 0);
      const other = field === "otherValue" ? (value || 0) : (dailyValues.otherValue || 0);
      const newCalculated = fixed + diet + other;

      if (newCalculated > 0) {
        newValues.dailyValue = newCalculated;
      }
    }

    setDailyValues(newValues);
  };

  const handleObservationChange = (e) => {
    setDailyValues((prev) => ({ ...prev, observation: e.target.value }));
  };

  const calculatePreviousCost = (herd) => {
    return (herd.numberOfDays * ((dailyValues.fixedValue || 0) + (dailyValues.dietValue || 0) + (dailyValues.otherValue || 0)) + (dailyValues.protocolValue || 0));
  };

  return (
    <Card
      style={{
        marginTop: 16,
        borderRadius: 7,
        background: "#fff",
        boxShadow: "0px 0px 10px #d8d8d8",
      }}
    >
      <Row type="flex" gutter={16}>
        {/* Item 1: Listagem de Conjuntos */}
        <Col span={12}>
          <Row style={{ marginBottom: 16 }}>
            <Col span={6}>
              <label style={{ fontWeight: "bold" }}>
                {translation.boitelContractsPage.form.dailyContract.cjt}
              </label>
            </Col>
            <Col span={6}>
              <label style={{ fontWeight: "bold" }}>
                {translation.boitelContractsPage.form.dailyContract.amountAnimals}
              </label>
            </Col>
            <Col span={6}>
              <label style={{ fontWeight: "bold", color: errors.dailyContract?.herdsWithDays?.some(h => h.numberOfDays) && submitCount > 0 ? "red" : "#9074bf" }}>
                {translation.boitelContractsPage.form.dailyContract.numberOfDays}
                *
              </label>
            </Col>
            <Col span={6}>
              <label style={{ fontWeight: "bold" }}>
                {translation.boitelContractsPage.form.dailyContract.prevCost}
              </label>
            </Col>
          </Row>
          {herdsWithDays.map((herd, index) => (
            <Row key={herd.id} gutter={8} style={{ marginBottom: 8 }}>
              <Col span={6}>
                <Input
                  value={index + 1}
                  disabled
                  style={{ textAlign: "center" }}
                />
              </Col>
              <Col span={6}>
                <Input
                  value={herd.amountAnimals || ""}
                  disabled
                  style={{ textAlign: "center" }}
                />
              </Col>
              <Col span={6}>
                <Input
                  type="number"
                  value={herd.numberOfDays || ""}
                  placeholder={
                    translation.boitelContractsPage.form.dailyContract
                      .numberOfDaysPlaceholder
                  }
                  onChange={(e) => {
                    const value = e.target.value ? parseInt(e.target.value) : null;
                    handleHerdDaysChange(herd.id, value);
                  }}
                  style={{ textAlign: "center" }}
                />
              </Col>
              <Col span={6}>
                <Input
                  value={numberMask(calculatePreviousCost(herd) || 0, true) || ""}
                  disabled
                  style={{ textAlign: "center" }}
                />
              </Col>
            </Row>
          ))}
        </Col>

        {/* Item 2: Campos de Valores */}
        <Col span={12}>
          <Row type="flex" gutter={16}>
            <Col xs={24} md={12} lg={12} xl={8} xxl={8}>
              <Row>
                <label>
                  {
                    translation.boitelContractsPage.form.dailyContract
                      .protocolValue
                  }
                </label>
              </Row>
              <Row>
                <NumberFormat
                  customInput={Input}
                  value={dailyValues.protocolValue || ""}
                  placeholder={
                    translation.boitelContractsPage.form.dailyContract
                      .protocolValuePlaceholder
                  }
                  decimalScale={2}
                  decimalSeparator=","
                  thousandSeparator="."
                  fixedDecimalScale={true}
                  addonBefore="R$"
                  addonAfter="/cab"
                  onValueChange={({ floatValue }) =>
                    handleValueChange("protocolValue", floatValue)
                  }
                />
              </Row>
            </Col>
            <Col xs={24} md={12} lg={12} xl={8} xxl={8}>
              <Row>
                <label>
                  {
                    translation.boitelContractsPage.form.dailyContract
                      .fixedValue
                  }
                </label>
              </Row>
              <Row>
                <NumberFormat
                  customInput={Input}
                  value={dailyValues.fixedValue || ""}
                  placeholder={
                    translation.boitelContractsPage.form.dailyContract
                      .fixedValuePlaceholder
                  }
                  decimalScale={2}
                  decimalSeparator=","
                  thousandSeparator="."
                  fixedDecimalScale={true}
                  addonBefore="R$"
                  addonAfter="cab/dia"
                  onValueChange={({ floatValue }) =>
                    handleValueChange("fixedValue", floatValue)
                  }
                />
              </Row>
            </Col>
            <Col xs={24} md={12} lg={12} xl={8} xxl={8}>
              <Row>
                <label>
                  {
                    translation.boitelContractsPage.form.dailyContract
                      .dietValue
                  }
                </label>
              </Row>
              <Row>
                <NumberFormat
                  customInput={Input}
                  value={dailyValues.dietValue || ""}
                  placeholder={
                    translation.boitelContractsPage.form.dailyContract
                      .dietValuePlaceholder
                  }
                  decimalScale={2}
                  decimalSeparator=","
                  thousandSeparator="."
                  fixedDecimalScale={true}
                  addonBefore="R$"
                  addonAfter="cab/dia"
                  onValueChange={({ floatValue }) =>
                    handleValueChange("dietValue", floatValue)
                  }
                />
              </Row>
            </Col>
          </Row>
          <Row type="flex" gutter={16} style={{ marginTop: 16 }}>
            <Col xs={24} md={12} lg={12} xl={8} xxl={8}>
              <Row>
                <label>
                  {
                    translation.boitelContractsPage.form.dailyContract
                      .otherValue
                  }
                </label>
              </Row>
              <Row>
                <NumberFormat
                  customInput={Input}
                  value={dailyValues.otherValue || ""}
                  placeholder={
                    translation.boitelContractsPage.form.dailyContract
                      .otherValuePlaceholder
                  }
                  decimalScale={2}
                  decimalSeparator=","
                  thousandSeparator="."
                  fixedDecimalScale={true}
                  addonBefore="R$"
                  addonAfter="cab/dia"
                  onValueChange={({ floatValue }) =>
                    handleValueChange("otherValue", floatValue)
                  }
                />
              </Row>
            </Col>
            <Col xs={24} md={12} lg={12} xl={8} xxl={8}>
              <Row>
                <label
                  className={
                    errors.dailyContract?.dailyValue && submitCount > 0
                      ? "error"
                      : ""
                  }
                >
                  {
                    translation.boitelContractsPage.form.dailyContract
                      .dailyValue
                  }
                  *
                </label>
              </Row>
              <Row>
                <NumberFormat
                  customInput={Input}
                  value={dailyValues.dailyValue || ""}
                  placeholder={
                    translation.boitelContractsPage.form.dailyContract
                      .dailyValuePlaceholder
                  }
                  decimalScale={2}
                  decimalSeparator=","
                  thousandSeparator="."
                  fixedDecimalScale={true}
                  addonBefore="R$"
                  disabled
                />
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Campo Observação */}
      <Row type="flex" gutter={16} style={{ marginTop: 16 }}>
        <Col span={24}>
          <Row>
            <label>
              {
                translation.boitelContractsPage.form.dailyContract
                  .observation
              }
            </label>
          </Row>
          <Row>
            <TextArea
              rows={3}
              value={dailyValues.observation}
              placeholder={
                translation.boitelContractsPage.form.dailyContract
                  .observationPlaceholder
              }
              onChange={handleObservationChange}
            />
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default DailyContractCard;

